import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { SharedService } from 'src/app/utils/shared.service';
import * as CommonConstants from '../../utils/common.constants';
import { AddTransferDetailComponent } from './add-transfer-detail/add-transfer-detail.component';
import { MasterService } from 'src/app/masters/master.service';

@Component({
  selector: 'app-ask-transfer',
  templateUrl: './ask-transfer.component.html',
  styleUrls: ['./ask-transfer.component.scss']
})
export class AskTransferComponent implements OnInit {
  transferList = [];
  form: FormGroup;
  medFileId;

  @Input()
  fileId;
  MD_FILE_PARAM_KEY = [CommonConstants.TRANSFER];
  ptype = [CommonConstants.PARTNER_PRACTITIONER_TYPE];
  PARAM_KEY = [CommonConstants.TRANSFER_REUESTED_BY, CommonConstants.TRANSFER_REASON];
  partnerList = [];
  specialistList = [];
  requestedBy = [];
  reason = [];

  @ViewChild(AddTransferDetailComponent, { static: true }) childAddTransferDetail: AddTransferDetailComponent;
  fileStatus: string;

  constructor(public router: Router, private formBuilder: FormBuilder, private medicalFileService: MedicalFileService,
    private sharedService: SharedService, private masterService: MasterService) { }

  ngOnInit() {
    this.fileStatus = localStorage.getItem(CommonConstants.FILE_STATUS);
    this.masterService.getPartnersByPartnerType(this.ptype);
    this.masterService.partnerList.subscribe(value => {
      this.partnerList = value;
      this.filterPartnerTypes();
      this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
        if (response && response['result']) {
          let masterValues = response['result'];
          this.requestedBy = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_REUESTED_BY);
          this.reason = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_REASON);
          this.getMedicalFilesByKey();
        }
      });
    });
  }

  filterPartnerTypes() {
    if (!this.partnerList) {
      this.masterService.getPartnersByPartnerType(this.ptype);
      this.masterService.partnerList.subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    } else {
      this.setPartners();
    }

  }

  setPartners() {
    if (this.partnerList) {
      this.specialistList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_PRACTITIONER_TYPE);
    }
  }

  getMedicalFilesByKey() {
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medFileId = res;
      this.transferList = [];
      this.medicalFileService.getMedicalFilesByKey(this.medFileId, this.MD_FILE_PARAM_KEY).subscribe(response => {
        if (response && response['code'] === 'S0000' && response['result']) {
          let masterValues = response['result'];
          if (masterValues) {
            this.transferList = (masterValues[CommonConstants.TRANSFER]);
            this.transferList = this.transferList.map(item => ({
              ...item,
              reasonDesc: item.reatrCode ? this.reason.find(obj => +obj.id === +item.reatrCode).value : null,
              requestedBy: item.prtieReferringId ? this.requestedBy.find(obj => +obj.id === item.prtieReferringId).value : null,
              specialist: item.prtieId ? this.specialistList.find(obj => +obj.partnerid === item.prtieId).partnername : null,
              medatBlEmergencyDesc: item.medatBlEmergency ? 'Yes' : 'No'
            }));
            /*  for(let item of this.transferList){
               item['reasonDesc']=item.reatrCode ? this.reason.find(obj => +obj.id === +item.reatrCode).value : null,
               item['requestedBy']=item.prtieReferringId ? this.requestedBy.find(obj => +obj.id === item.prtieReferringId).value : null,
               item['specialist']=item.prtieId ? this.requestedBy.find(obj => +obj.id === item.partnerid)[0].partnername : null,
               item['medatBlEmergencyDesc']=item.medatBlEmergency ? 'Yes' : 'No'
             } */
          }
        }
      })
    })
  }

  private getFormGroup() {
    this.form = this.formBuilder.group({
      'relatId': new FormControl(),
      'persoVaFirstname': new FormControl(),
      'persoVaLastname': new FormControl(),
      'patientNumber': new FormControl(),
      'persoDtBirthDate': new FormControl()
    })
  }

  onTransferRowSelect(row) {
    if (this.fileStatus === 'NEW') {
      this.router.navigate(['addTransfer'], { state: { row: row.data } })
    }
  }


  addTransfer() {
    this.router.navigate(['addTransfer']);
  }
}
